import { Controller } from "@hotwired/stimulus"

// Tabela leadów — część KLIENCKA: zaznaczanie wierszy + masowe dodanie do koszyka.
//
// Sortowanie i paginacja są SERVER-SIDE (parametry URL; wiersze renderuje kontroler
// `catalog` z DRF) — ten kontroler ich nie dotyka.
//
// Tryb zakupu (smoke-ins#5): segmentowany przełącznik w bulkbarze ustawia #mode
// ("exclusivity" domyślnie lub "slot"). Przy "Dodaj zaznaczone" kontroler wysyła
// JEDEN request { listing_ids, mode } dla całego zaznaczenia — nie grupuje per-wiersz.
// Wiersze odrzucone przez API (nie w `added`) dostają `is-rejected` na wierszu +
// przycisk disabled + etykieta "Niedostępny".
export default class extends Controller {
  static targets = ["row", "bulkbar", "selCount", "addBtn"]
  static values  = {
    addUrl: String,
    purchasingEnabled: { type: Boolean, default: true }, // false = personel jeszcze nie zweryfikował klienta — blokuje "Dodaj zaznaczone"
  }

  connect() {
    // Zaznaczanie wierszy zostaje możliwe (nieszkodliwe) — blokujemy tylko samo dodanie:
    // przycisk disabled (backend i tak 403-uje, ale nie może wyglądać na klikalny) +
    // addSelected() poniżej ma tę samą blokadę jako no-op na wszelki wypadek.
    if (this.hasAddBtnTarget && !this.purchasingEnabledValue) {
      this.addBtnTarget.disabled = true
      this.addBtnTarget.title = "Konto nie zostało jeszcze zweryfikowane — skontaktuj się z nami, aby aktywować zakupy."
      this.addBtnTarget.hidden = true
      const pending = this.addBtnTarget.parentElement?.querySelector('[data-field="pendingLabel"]')
      if (pending) pending.hidden = false
    }
    this.#refresh()
  }

  toggleRow() { this.#refresh() }

  clear() {
    this.rowTargets.forEach(cb => { cb.checked = false; this.#markRow(cb, false) })
    this.#refresh()
  }

  // smoke-0909#3: nie POST-uje bezpośrednio — deleguje do modalu trybu w kontrolerze `cart`.
  // Wybór Wyłączność / Slot i POST do /api/cart/add-bulk/ obsługuje cart#confirmMode.
  addSelected() {
    if (!this.purchasingEnabledValue) return // konto niezweryfikowane — patrz connect()
    // Pomiń pozycje już będące w koszyku.
    const ids = this.#selectedIds().filter(id => {
      const btn = document.querySelector(`.ls-add-btn[data-cart-id-param="${id}"]`)
      return !btn?.classList.contains("is-in-cart")
    })
    if (!ids.length) {
      this.clear()
      return
    }
    const cartEl = document.querySelector('[data-controller~="cart"]')
    if (cartEl) {
      const ctrl = this.application.getControllerForElementAndIdentifier(cartEl, "cart")
      if (ctrl) {
        ctrl.openModeBulk(ids, this.addUrlValue, () => this.clear())
        return
      }
    }
    // Fallback: brak kontrolera cart (np. strona bez koszyka) — wyczyść zaznaczenie.
    this.clear()
  }

  // --- prywatne ---
  #selectedIds() { return this.rowTargets.filter(cb => cb.checked).map(cb => Number(cb.value)) }

  #refresh() {
    const n = this.#selectedIds().length
    this.rowTargets.forEach(cb => this.#markRow(cb, cb.checked))
    if (this.hasBulkbarTarget)  this.bulkbarTarget.hidden = n === 0
    if (this.hasSelCountTarget) this.selCountTarget.textContent = n
  }

  #markRow(cb, on) {
    const row = cb.closest(".ls-lead-row")
    if (!row) return
    // Podświetlenie zostaje, gdy wiersz jest w koszyku (is-selected pełni też rolę "in cart").
    const inCart = row.querySelector(".ls-add-btn")?.classList.contains("is-in-cart") ?? false
    row.classList.toggle("is-selected", on || inCart)
  }
}
